export default __webpack_public_path__ + "static/triangle-right.url-b0293f39ee3263a9ea45f262e4017b74.svg";